module.exports = __webpack_public_path__ + "static/me-bdaa54a37bd2b05bb45532923367f88e.png";